// constants/languages.ts
export const languages = [
    { label: "English", value: "en" },
    { label: "Español", value: "es" },
    { label: "Français", value: "fr" },
    { label: "Deutsch", value: "de" },
    { label: "Türkçe", value: "tr" },
  ];
  